import { IconClipboardPlus, IconListCheck } from "@tabler/icons-react";
import { ModuleLanding } from "../../shell/ModuleLanding";

export function MarketingHome() {
  return (
    <ModuleLanding
      title="Marketing"
      subtitle="Day orders from the field"
      tiles={[
        {
          to: "/marketing/pre-order",
          label: "Place a day order",
          blurb: "Capture the site visit and what the customer wants",
          icon: <IconClipboardPlus size={21} stroke={1.6} />,
        },
        {
          to: "/marketing/pre-orders",
          label: "My day orders",
          blurb: "What you have placed and where it got to",
          icon: <IconListCheck size={21} stroke={1.6} />,
        },
      ]}
    />
  );
}
